// Shared like/unlike calls, matching the request shapes the grid Card already
// uses (src/component/Card.jsx: fetchLikedStatus / toggleLike). Kept in one
// place so the fullscreen ImmersiveFeed's heart button behaves identically to
// the grid without duplicating the fetch logic. `token` is a raw Firebase
// idToken (no "Bearer" prefix), same as Card.

const CLOUD = process.env.NEXT_PUBLIC_PROMPTCHAN_CLOUD

async function postJson(path, token, body) {
  const res = await fetch(`${CLOUD}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw new Error(`${path} failed: ${res.status}`)
  return res
}

// Returns whether the current user has liked this image.
export async function checkLiked(imageId, token) {
  const res = await postJson('/api/check_liked_image', token, {
    image_id: imageId,
  })
  const data = await res.json()
  return Boolean(data?.liked)
}

// `imageData` is the feed item object (same shape Card sends).
export async function likeImage(imageData, token) {
  await postJson('/api/like_image', token, { imageData })
}

export async function unlikeImage(imageData, token) {
  await postJson('/api/unlike_image', token, { imageData })
}
